import React, { useEffect } from "react";
import "./WhatWeDo.css";
import { FaArrowRight } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const items = [
  {
    img: "/img4.webp",
    title: "REGULAR MEDICAL CARE & HEALTH MONITORING",
    desc: "We ensure that every elder receives consistent and careful medical attention. Our team conducts routine health check-ups, monitors vital signs, tracks medications, and keeps detailed health records. By staying updated on each senior’s medical condition, we can identify issues early and provide timely treatment. Our goal is to give elders a safe, healthy, and worry-free life through continuous medical support and professional care.",
  },
  {
    img: "/Gal9.jpg",
    title: "Listening to Every Need",
    desc: "Our dedicated volunteers actively engage with community members to identify their requirements. By speaking directly to people, understanding their concerns, and listening to their stories, we ensure that every need is documented and addressed with responsibility. This approach helps us offer solutions that truly make a difference in their lives.",
  },
  {
    img: "/lunch.jpg",
    title: "Nutritious & Hygienic Meals for Elders",
    desc: "Good food is essential for a peaceful and healthy life. That is why we serve our elders safely prepared, hygienic, and nutritious meals every day. From selecting fresh vegetables to maintaining a clean kitchen, we ensure that each plate supports their well-being. Our meals are cooked with care, keeping in mind their age, health conditions, and dietary needs. We believe that providing clean and healthy food is one of the greatest acts of care we can offer to our seniors.",
  },
];

const WhatWeDo = () => {
  /* ---------------- AOS INIT ---------------- */
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 120,
    });
  }, []);

  return (
    <div className="wwd-section">
      <h2 className="wwd-title" data-aos="fade-up">What we do for elders</h2>
      <div className="wwd-underline" data-aos="fade-left"></div>

      <div className="wwd-container">
        {items.map((item, index) => (
          <div
            className="wwd-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 150}
          >
            <img src={item.img} alt={item.title} className="wwd-img" />

            {/* Overlay */}
            <div className="wwd-overlay">
              <p className="wwd-text">{item.title}</p>
              <FaArrowRight className="wwd-arrow" />

              {/* Hover Details */}
              <div className="wwd-details">
                <p>{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatWeDo;
